const React = require("react-native");

const { StyleSheet, Platform } = React;

export default {
  container: {
    flex: 1,
    width: null,
    height: null,
    backgroundColor: "#FFF"
  },
  iconContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-around",
    paddingLeft: 15
  },
  iconText: {
    fontSize: 12
  },
  icon: {
    width: 45,
    height: 45,
    justifyContent: "center"
  },
  col: {
    alignItems: "center",
    paddingHorizontal: 3
  },
  row: {
    paddingBottom: 20
  }
};



// WEBPACK FOOTER //
// ./src/js/components/icon/styles.js